// Service module client metadata — icons for each module including new ride_hailing
import {
  UtensilsCrossed, Wrench, Package, Pill, ShoppingBasket, Hotel, Building2, Briefcase, Car,
} from "lucide-react";

export const MODULE_ICONS = {
  restaurants: UtensilsCrossed,
  home_services: Wrench,
  courier: Package,
  pharmacy: Pill,
  grocery: ShoppingBasket,
  hotels: Hotel,
  flats: Building2,
  business: Briefcase,
  ride_hailing: Car,
};

// Emoji fallback / cultural markers (used for ride_hailing to show tuk-tuk clearly)
export const MODULE_EMOJI = {
  restaurants: "🍽️",
  home_services: "🔧",
  courier: "📦",
  pharmacy: "💊",
  grocery: "🛒",
  hotels: "🏨",
  flats: "🏢",
  business: "💼",
  ride_hailing: "🛺",
};

export const STATUS_LABEL = {
  live: { en: "Live", ar: "نشط" },
  coming_soon: { en: "Soon", ar: "قريبًا" },
  off: { en: "Off", ar: "معطل" },
};
